import { PERIOD_GRANULARITIES, PERIOD_PRESET_OPTIONS } from '../constants/period.constant';
import type { PeriodGranularityType, PeriodPresetOptionType } from '../types/period.type';

/**
 * Narrows an unknown value (a stored filter value, a query param) to a supported granularity.
 */
export function isPeriodGranularity(value: unknown): value is PeriodGranularityType {
  return typeof value === 'string' && PERIOD_GRANULARITIES.includes(value as PeriodGranularityType);
}

/**
 * Narrows an unknown value to one of the preset period keys.
 */
export function isPeriodPresetOption(value: unknown): value is PeriodPresetOptionType {
  return typeof value === 'string' && PERIOD_PRESET_OPTIONS.includes(value as PeriodPresetOptionType);
}
